

























export default {
  props: {
    unit: { type: String, default: 'cm' },
    value: { type: Object, required: true }
  },
  data() {
    return {
      weight: {
        maxWeight: null,
        minWeight: null
      }
    }
  },
  watch: {
    value(value) {
      this.weight = value
    }
  },
  created() {
    this.maxValidator = [
      {
        isInvalid: this.isMaxValueValid,
        errorMessage: this.$t(
          'marketPlace.fixedFilters.loadDimensions.maxValueValidation'
        )
      }
    ]
  },
  methods: {
    isMaxValueValid(): boolean {
      const { minWeight, maxWeight } = this.weight
      return minWeight && maxWeight && minWeight > maxWeight
    }
  }
}
